import PropTypes from "prop-types";

import ActionButton from "../../../formInputs/buttons/ActionButton";

const SubjectComments = ({ canEdit, onSave, selectedTemplate, setValue, student, subjectComment, value }) => {
    if (!selectedTemplate) return null;
    return (
        <section className="section-card">
            <header className="section-card__header">
                <h5 className="section-card__title">{selectedTemplate?.subjectName || ""} Comments</h5>
            </header>
            <div className="section-card__body comments-stack">
                {/* Class-wide subject comment */}
                <div className="comment-card">
                    <div className="comment-card__title">Class Comment</div>
                    <div>
                        {subjectComment ? (
                            subjectComment
                        ) : (
                            <span style={{ fontStyle: "italic" }}>No comment entered</span>
                        )}
                    </div>
                </div>

                {/* Student + subject comment */}
                <div className="comment-card">
                    <div className="comment-card__title">
                        {student.firstName} {student.lastName}&#39;s {selectedTemplate.subjectName} Comment
                    </div>
                    <textarea
                        className="comment-textarea"
                        disabled={!canEdit}
                        rows={2}
                        value={value}
                        onChange={(e) => setValue(e.target.value)}
                        placeholder={`Add a ${selectedTemplate.subjectName} note for ${student.firstName}…`}
                    />
                    <div className="comment-actions">
                        <ActionButton
                            label={`Save ${student.firstName}'s ${selectedTemplate.subjectName} Comment`}
                            onClick={onSave}
                            disable={!canEdit}
                        />
                    </div>
                </div>
            </div>
        </section>
    );
};

SubjectComments.propTypes = {
    canEdit: PropTypes.bool,
    onSave: PropTypes.func.isRequired,
    selectedTemplate: PropTypes.shape({
        subjectName: PropTypes.string.isRequired,
        templateId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    }).isRequired,
    setValue: PropTypes.func.isRequired,
    student: PropTypes.shape({
        firstName: PropTypes.string.isRequired,
        lastName: PropTypes.string.isRequired,
        studentNumber: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    }).isRequired,
    subjectComment: PropTypes.string,
    value: PropTypes.string.isRequired
};

export default SubjectComments;
